import { render, staticRenderFns } from "./visitListCard.vue?vue&type=template&id=48f7e204&scoped=true"
import script from "./visitListCard.vue?vue&type=script&lang=js"
export * from "./visitListCard.vue?vue&type=script&lang=js"
import style0 from "./visitListCard.vue?vue&type=style&index=0&id=48f7e204&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f7e204",
  null
  
)

export default component.exports